import React, { useContext, useState } from "react"
import { MobergCheckbox, MobergColumn, MobergHeader, MobergRow, MobergText } from "../../../../../Moberg"
import { ConfigureWindowModalContext } from "../ConfigureWindowModal"
import { RenderStrategy } from "../../../../../Pages/Data/Visualize/DataReview/Types/Trace"
import { EMRDataFilter } from "../../../../../Pages/Data/Visualize/DataReview/Types/Graph"

const GCS = [
    "GCS Best Motor Response", 
    "GCS Best Verbal Response", 
    "GCS Eye Opening", 
    "Glasgow Coma Scale Score"
]

const SNAP = [
    "Communication",
    "Natural Airway Communication",
    "Artificial Airway Communication", 
    "Cranial Nerves", 
    "Left Lower Extremity",
    "Left Upper Extremity", 
    "Mental Status", 
    "Right Lower Extremity", 
    "Right Upper Extremity", 

]

const FLOWSHEET_OPTIONS = {
    GCS, 
    SNAP
}


export const FlowsheetGraphModalities: React.FC = () => {
    const { currentGraph, updateGraphProperty } = useContext(ConfigureWindowModalContext)
    const [filters, setFilters] = useState<Array<EMRDataFilter>>(currentGraph?.renderStrategy === RenderStrategy.FLOWSHEET ? (currentGraph?.filters ?? []) : [])

    const updateFilters = (filters: EMRDataFilter[], shouldInclude: boolean) => {
        setFilters(previous => {
            const incomingIds = new Set(filters.map(f => f.id))

            const result = shouldInclude
                ? [...previous, ...filters.filter(f => !previous.some(p => p.id === f.id))]
                : previous.filter(p => !incomingIds.has(p.id))

            updateGraphProperty("filters", result)
            return result
        })
    }

    return (
        <MobergRow verticalAlign="start">
            {Object.entries(FLOWSHEET_OPTIONS).map(([flowsheetDataType, options]) => (
                <MobergColumn key={flowsheetDataType} style={{ padding: "8px" }}>
                    <MobergHeader>{flowsheetDataType}</MobergHeader>
                    {options.map(option => (
                        <MobergRow key={option} gap="8px">
                            <MobergCheckbox isChecked={!!filters.find(f => f.id === option)} onChange={isChecked => updateFilters([{ id: option, name: option }], isChecked)} />
                            <MobergText>{option}</MobergText>
                        </MobergRow>
                    ))}
                </MobergColumn>
            ))}

        </MobergRow>
    )
}
